import React, { useState } from 'react';
import { omit } from 'ramda';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import useApp from 'reducers/hooks/useApp';
import Alert from 'sharedComponents/Alert';

import GoogleAuthButton from 'sharedComponents/GoogleAuthButton';

import BuyerRegistrationForm from 'sharedComponents/BuyerRegistrationForm';
import { getServerErrorsFullMessages, getServerError } from 'utils/errors';

import useStyles from './useStyles';

const BuyerRegistration = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { signUp, loginWithGoogle } = useApp();
  const { onFinish } = props;

  const [alert, setAlert] = useState({ show: false, text: '', severity: '' });
  const handleCloseAlert = () => setAlert({ ...alert, show: false });

  const handleSubmit = async values => {
    const attrs = omit('passwordConfirmation', values);
    try {
      await signUp({ ...attrs, userType: 'buyer' });
      onFinish();
    } catch (err) {
      const error = getServerError(err);
      setAlert({ show: true, text: error, severity: 'error' });
    }
  };

  const handleSignUpWithGoogle = async response => {
    const { credential } = response;

    try {
      await loginWithGoogle({ tokenId: credential, provider: 'google_oauth2' });
      onFinish();
    } catch (_err) {
      const { fullErrorMessages } = getServerErrorsFullMessages(_err);
      setAlert({ show: true, text: fullErrorMessages, severity: 'error' });
    }
  };

  return (
    <Box className={classes.container}>
      <Typography variant="body1">{t('components.SignUp.BuyerRegistration.header')}</Typography>
      <div className={classes.socialBox}>
        <GoogleAuthButton onSuccess={handleSignUpWithGoogle} />
      </div>
      <div className={classes.divider}>
        <div className={classes.line} />
        <Typography variant="body1">{t('components.SignUp.BuyerRegistration.or')}</Typography>
        <div className={classes.line} />
      </div>
      <BuyerRegistrationForm onSubmit={handleSubmit} />
      {alert.show && <Alert text={alert.text} open severity={alert.severity} handleClose={handleCloseAlert} />}
    </Box>
  );
};

BuyerRegistration.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default BuyerRegistration;



// WEBPACK FOOTER //
// ./src/components/SignUp/components/BuyerRegistration/BuyerRegistration.js